<template>
  <l-cache :get-data="getRole" :id="$route.query.id" ref="cache">
    <role-form :role="data" @refresh="$refs.cache.retry(true)" slot-scope="{data}"></role-form>
  </l-cache>
</template>

<script>
import RoleForm from './roleForm'

export default {
  name: 'EditRole',
  components: {RoleForm},
  methods: {
    async getRole () {
      let {items} = await this.$store.dispatch('userAdmin/getRoles', {
        pagination: {},
        filter: [{key: 'id', value: this.$route.query.id}]
      })
      if (items && items.length > 0) {
        let role = items[0]
        role.showGU = false
        return role
      }
      else {
        throw Error('未找到该角色')
      }
    },
  }
}
</script>

<style scoped>

</style>
